module.exports = __webpack_public_path__ + "img/pro.dbaaf7e5.png";